import { createContext } from 'react';

import { IApplicationContext } from 'types/application';

export const ApplicationContext = createContext<IApplicationContext>({ updateContext: () => {}, loaded: false });
